import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { useCameraStateRecorder } from "../../engine/live/room/cameraTelemetry"
import LiveEventBuffer from "@data/services/LiveEventBuffer"
import moment from "moment"
import React from "react"
import { useWindowDimensions, View } from "react-native"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { connect } from "react-redux"
import live from "../../../assets/icons/generic/live.png"
import { findClosestNextOccurrence } from "../../student/account/onboarding/LiveRoomCard"
import TouchableRippleM from "../components/button/TouchableRippleM"
import { IconImageM } from "../components/icons/IconsM"
import TextM from "../components/text/TextM"
import StudentControlBar from "../livekit/components-web/StudentControlBar"
import { theme } from "../theme/theme"

const StudentLiveModeFooter = (props) => {
    const {
        height,
        miniMode,
        setMiniMode,
        setFocusedMode,
        nav,
        route,
        backgroundColor,
        isSoundMode,
    } = props
    const liveSession = props.currentLiveSession

    const closestNextOccurrence = findClosestNextOccurrence([liveSession])

    const liveMoment = closestNextOccurrence?.date
        ? moment(closestNextOccurrence?.date)
        : null

    const { width: windowWidth } = useWindowDimensions()
    const insets = useSafeAreaInsets()

    const debouncedOnOffCam = useCameraStateRecorder()

    // Initialize the event buffer for batched event syncing (safe to call multiple times)
    React.useEffect(() => {
        if (props.liveSessionId && props.user?.id) {
            LiveEventBuffer.getInstance().init(
                props.liveSessionId,
                props.user.id
            )
        }
    }, [props.liveSessionId, props.user?.id])

    return (
        <View
            style={{
                backgroundColor,
                justifyContent: "center",
                alignItems: "center",
                alignSelf: "center",
                height,
                borderTopWidth: 1,
                borderColor: theme.colors.lightMore,
                width: windowWidth,
                marginBottom: insets.bottom,
            }}
        >
            <View
                style={{
                    width: "100%",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingHorizontal: windowWidth >= 700 ? 20 : 0,
                }}
            >
                {windowWidth >= 700 && (
                    <TouchableRippleM
                        style={{
                            alignItems: "center",
                            width: 210,
                        }}
                        disabled={true}
                    >
                        <View
                            style={{
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <IconImageM source={live} width={36} />
                            <View>
                                <TextM
                                    fontSize={16}
                                    fontWeight={"ExtraBold"}
                                    color={theme.colors.success}
                                    style={{
                                        paddingLeft: 5,
                                    }}
                                >
                                    LIVE{" "}
                                    <TextM
                                        fontSize={15}
                                        fontWeight={"Light"}
                                        color={theme.colors.success}
                                        style={{}}
                                        wrap
                                    >
                                        {liveSession?.live_room?.name}
                                    </TextM>
                                </TextM>
                                <TextM
                                    fontSize={11}
                                    fontWeight={"Light"}
                                    ellipsizeMode={"tail"}
                                    color={theme.colors.success}
                                    style={{
                                        paddingLeft: 5,
                                        marginTop: -2,
                                    }}
                                >
                                    {moment(liveMoment)?.format(
                                        "ddd D MMM HH:mm"
                                    )}
                                </TextM>
                            </View>
                            <View
                                style={{
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "row",
                                    paddingLeft: 12,
                                    marginLeft: 12,
                                    borderLeftWidth: 1,
                                    borderColor: theme.colors.lightMore,
                                    height: 24,
                                }}
                            >
                                <TextM
                                    fontSize={14}
                                    fontWeight={"Medium"}
                                    ellipsizeMode={"tail"}
                                    color={theme.colors.success}
                                    style={{}}
                                    wrap
                                >
                                    {moment()?.format("HH:mm")}
                                </TextM>
                            </View>
                        </View>
                    </TouchableRippleM>
                )}

                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingLeft: windowWidth >= 700 ? 12 : 0,
                        marginLeft: windowWidth >= 700 ? 12 : 0,
                    }}
                >
                    <StudentControlBar
                        miniMode={miniMode}
                        setMiniMode={setMiniMode}
                        setFocusedMode={setFocusedMode}
                        nav={nav}
                        route={route}
                        onOffCam={debouncedOnOffCam}
                        backgroundColor={backgroundColor}
                        isSoundMode={isSoundMode}
                        style={{}}
                    />
                </View>
                {windowWidth >= 700 && <View style={{ width: 210 }} />}
            </View>
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        currentLiveSession: state.data.currentUser?.object?.live_sessions?.find(
            (x) => x?.id === state.liveMode?.liveSessionId
        ),
        user: state.data.currentUser?.object,
        liveSessionId: state.liveMode?.liveSessionId,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentLiveModeFooter)
